import { render, staticRenderFns } from "./sensory-overload-a45.vue?vue&type=template&id=b4dd7a58&"
import script from "./sensory-overload-a45.vue?vue&type=script&lang=js&"
export * from "./sensory-overload-a45.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports